import React, { useEffect, useState } from 'react'
import emailConfig from '../emailConfigs'
import EmailsToClipBoard from './EmailsToClipBoardInstallation'
import SpareWithQty from '../../../components/widgets/sparepart/SpareWithQty'
import CONSTANTS from '../../../CONSTANTS'
import { Button, IconButton, TextField } from '@mui/material'
import DeleteIcon from '@mui/icons-material/Delete';
import InputSelectDropdown from '../../../elements/dropdowns/InputSelectDropdown'
import clientsList from "../../../assets/client/client_data.json"
import API from '../../../methods/API'
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';

const EmailsInstallation = () => {
    const [form, setForm] = useState({})
    const [selectedSpare, setSelectedSpare] = useState({ unit: "no", quantity: 1 })
    const [isShowMail, setSetShowMail] = useState(true)
    const [list, setList] = useState([])

    const { QUESTIONS } = emailConfig


    const {
        RECOMMENDED_COMPONENTS,
        TYPE_OF_PLANT
    } = QUESTIONS

    // let initiationProps = {
    //     options: CONSTANTS.INITIATION_TYPE_OF_SERVICE,
    //     id: "initiation",
    //     selectedValues: form["initiation"],
    //     inputprops: {
    //         label: "Type Of Service"
    //     },

    // }
    // let serviceModeProps = {
    //     options: CONSTANTS.MODE_OF_SERVICE,
    //     id: "serviceMode",
    //     selectedValues: form["initiation"],
    //     inputprops: {
    //         label: "Mode Of Service"
    //     },

    // }


    const handleRadio = (key, val) => {
        setForm(prev => ({ ...prev, [key]: val }))
    }

    const removeItem = (key, removedItem) => {
        setSelectedSpare(prev => {
            return { ...prev, [key]: selectedSpare[key].filter(item => item.label !== removedItem.label) }
        })
    }

    const renderRadioV2 = (obj) => {
        return <div className="radio-con checkbox-gen" key={obj.key}>
            <div className="typography-line pad-l0">
                <div>{obj.question}</div>
                <div className='nudge'>{obj.nudge}</div>
            </div>
            <div className="input-div d-flex">
                {obj.options.map(item => {
                    return (
                        <div className={`form-check-radio ${form[obj.key] === item.value ? "greenC" : ""}`}>
                            <input
                                id={`${obj.key}_${item.key}`}
                                name={`${obj.key}_${item.key}`}
                                type="radio"
                                // defaultValue="Yes"
                                defaultChecked=""
                                checked={form[obj.key] === item.value}
                                onChange={() => handleRadio(obj.key, item.value)}
                            />
                            {item.displayName}
                            <span className="form-check-sign" />
                        </div>
                    )
                })}
            </div>
            {selectedSpare[obj.key] && !!selectedSpare[obj.key].length && <div className='selected-spare-main'>
                <ul>
                    {selectedSpare[obj.key].map((item, index) => (<li key={index}>{index + 1}. {item.label} - {item.quantity} {CONSTANTS.SPARE_UNIT_MAPPING[item.unit]}
                        <IconButton aria-label="delete" color='red' onClick={() => removeItem(obj.key, item)}>
                            <DeleteIcon fontSize="small" sx={{ color: 'red' }} />
                        </IconButton>
                    </li>
                    )
                    )}
                </ul>
            </div>}
            {form[obj.key] && obj.showRecommendedSpareDropdown &&
                <div>
                    <SpareWithQty slug={obj.key} cb={handleSelect} />
                </div>
            }
        </div>

    }

    const renderGetEmailButton = () => {
        return <div className="d-flex pm10 ">
            <Button variant="contained" onClick={() => {
                setSetShowMail(true)
                window.scrollTo({
                    top: document.body.scrollHeight,
                    behavior: "smooth"
                });
            }}>Generate Email</Button>
        </div>
    }

    const handleSelect = (key, val) => {
        if (!val) {
            return
        }

        setSelectedSpare(prev => ({ ...prev, [key]: [...(selectedSpare[key] || []), val] }))
    }
    // const handleSelectDropDown = (e, key, value) => {
    //     setForm(prev => ({ ...prev, [key]: value }))
    // }
    const handleSelectClient = (e, key, val) => {
        if (!val) {
            return
        }
        if (val.client_name === "Other") {
            setForm(prev => ({ ...prev, isOtherSelected: true, client: {} }))
        } else {
            setForm(prev => ({ ...prev, [key]: val }))
        }
    }
    useEffect(() => {
        getModifiedOptions()
    }, [])

    const getModifiedOptions = async () => {
        let modList = []
        let other = {
            "client_name": "Other",
            "client_code": "VACSPLCLIENT_NEW",
            "city": "",
            "state": "",
            "country": "",
            "type_of_plant": "",
            "label": "Other",
            "key": "Other",
        }
        try {

            modList = await clientsList.map(item => ({ ...item, label: `${item.client_name}`, key: item.client_code }))
            let allClientOnServer = await API.getAllClient()
            allClientOnServer.forEach(item => {
                modList.push({
                    ...item,
                    label: item.client_name,
                    key: item.client_code,
                    id: item._id,
                })
            })
            // modList.sort((a,b)=>a.label-b.label)
        } catch (err) {
            console.log(err)
        }
        setList([other, ...modList])
    }
    const renderServiceDate = () => {
        return <div className='pad-l20'>
            <div style={{ padding: '20px' }} className="date-picker-container">
                {/* <h2>Servce Date</h2> */}
                <DatePicker
                    selected={form.serviceDate}
                    onChange={(date) => {
                        setForm(prev => ({ ...prev, serviceDate: date }))
                    }}
                    dateFormat="yyyy-MM-dd"
                    isClearable
                    placeholderText="Enter Installation Date"
                    className="custom-date-picker"
                />
                {/* {selectedDate && (
                    <p>Service Date: {selectedDate.toLocaleDateString()}</p>
                )} */}
            </div>
        </div>

    }

    // const renderDropDown = (propsData) => {

    //     return (
    //         <div className='pad-l20'>

    //             <SelectAutoWidth {...propsData} cbSelect={handleSelectDropDown} />
    //         </div>
    //     )
    // }

    const renderClientNameField = () => {
        let dropProps = {
            id: "client",
            options: list,
            selectedValues: form["client"],
            inputprops: {
                id: "",
                value: form["client"],
                label: "Select Client"
            },
            cbSelect: handleSelectClient,
            width: 500
            // cbInput:
        }
        return (
            <div className='pad-l20'>
                <InputSelectDropdown {...dropProps} />
            </div>
        )
    }
    const handleText = (e, a, b) => {
        const { name, value } = e.target
        if (name === "serviceBookNo") {
            setForm(prev => ({ ...prev, [name]: value }))
        } else {
            setForm(prev => ({
                ...prev,
                client: {
                    "client_name": value,
                    "client_code": "VACSPLCLIENT_NEW",
                    "city": "",
                    "state": "",
                    "country": "",
                    "type_of_plant": "",
                    "label": value,
                    "key": value,
                }
            }))
        }
    }
    const renderManualCompany = () => {
        return <div className='radio-con'>
            <TextField
                id="outlined-basic"
                label="Client Name"
                variant="outlined"
                name="client"
                value={form.newClient}
                onChange={handleText}
            />
        </div>
    }

    const renderBookNo = () => {
        return <div className='radio-con'>
            <TextField
                id="outlined-basic"
                label="Service Book No."
                variant="outlined"
                name="serviceBookNo"
                value={form.serviceBookNo}
                onChange={handleText}
                type="number"
            />
        </div>
    }

    // const isExistinList = ()=>{
    //     if(!form || !form.client || !form.client.client_name){
    //         return false
    //     }

    //     if(form.client.client_name==="Other" ){
    //         return true
    //     }

    //     return false
    // }


    const renderForm = () => {
        return (
            <div className='email-form-page'>
                <h2>Create Email for Service Email to Customer</h2>


                {renderServiceDate()}
                <div>
                    {/* {renderDropDown(initiationProps)} */}
                    {/* {renderDropDown(serviceModeProps)} */}
                </div>
                {renderBookNo()}
                {!form.isOtherSelected ? renderClientNameField() : <div className='radio-con pointer blue' onClick={() => setForm(prev => ({ ...prev, isOtherSelected: false }))}><span>Select From List</span></div>}
                {form.isOtherSelected && renderManualCompany()}
                {form && form.client && form.client.client_name && <div className='radio-con'>
                    Company Name: <span><strong>{form.client.client_name}</strong></span>
                </div>}

                {renderRadioV2(TYPE_OF_PLANT)}
                {/* {renderRadioV2(NO_ISSUE_FOUND)} */}

                {renderRadioV2(RECOMMENDED_COMPONENTS)}

                {renderGetEmailButton()}

            </div>
        )
    }

    return (
        <div className='main-email-d'>
            {renderForm()}
            {isShowMail && <div className='email-form-page'>
                <EmailsToClipBoard form={form} selectedSpare={selectedSpare} spareConf={RECOMMENDED_COMPONENTS} />
            </div>}
        </div>
    )
}

export default EmailsInstallation






